// Adjust this import to match your project's axios instance / http client
import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
 
/**
* Create a new delivery boy
* POST /Store/{storeId}/CreateCashierDeliveryBoy
* payload: { company_id, name, phone_no }
*/
export const createDeliveryBoy = async (storeId, payload) => {
  try {
    const response = await axiosInstance.post(
      URLS.CREATE_CASHIER_DELIVERY_BOY,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating delivery boy:", error);
    throw error;
  }
};
 
/**
 * Get list of delivery boys (supports search, pagination)
 * POST /Store/{storeId}/GetCashierDeliveryBoy
 * payload: { company_id, search, limit, offset }
 */


export const getAllDeliveryBoys = async (payload) => {
  const response = await axiosInstance.post(
    URLS.GET_CASHIER_DELIVERY_BOY,
    payload
  );
  return response.data;
};
 
/**
* Update / soft-delete a delivery boy
* POST /Store/{storeId}/UpdateCashierDeliveryBoy
* payload: { company_id, delivery_boy_id, name, phone_no, is_delete }
*/
export const updateDeliveryBoy = async (storeId, payload) => {
  try {
    const response = await axiosInstance.post(
      URLS.UPDATE_CASHIER_DELIVERY_BOY,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating delivery boy:", error);
    throw error;
  }
};